import { render } from "./TheCheckout.vue?vue&type=template&id=0c2d552f&scoped=true"
import script from "./TheCheckout.vue?vue&type=script&lang=js"
export * from "./TheCheckout.vue?vue&type=script&lang=js"

import "./TheCheckout.vue?vue&type=style&index=0&id=0c2d552f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2d552f"]])

export default __exports__